import React, { useEffect, useState, useContext, useCallback } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AlertModal from '../../AlertModal/index';

import ModalDenunciations from '../Denunciations/index';

import ConfirmAction from '../ConfirmDelete/index';
import ConfirmModal from '../../ConfirmModal/index';
import BlockIcon from '../../../../assets/Icons/ModalPJ/block.svg';
import UnBlockIcon from '../../../../assets/Icons/ModalPJ/unblock.svg';
import AlertIcon from '../../../../assets/Icons/ModalPJ/alert.svg';
import TrashIcon from '../../../../assets/Icons/ModalPJ/trash.svg';
import Cross from '../../../../assets/Icons/cross.svg';
import MyContext from '../../../../contexts/_ModalData/modal';
import api from '../../../../services/api';

import './styles.css';

export default ({show, setShow, changeStatus, ouvidoria }) => {

    const[showModalConfirm, setShowModalConfirm] = useState(false);
    const[title, setTitle] =  useState('');
    const[text, setText] =  useState('');

    const[showConfirmAction, setShowConfirmAction] = useState(false);
    const[textConfirm, setTextConfirm] = useState('');

    const[isBlocked, setIsBlocked] = useState(false);

    const[showProgress, setShowProgress] = useState(false);

    const[showAlertModal, setShowAlertModal] = useState(false);
    const[alertMessage, setAlertMessage] = useState('');

    const { dataPF, setDenunciations } = useContext(MyContext);

    const [denunces, setDenunces] = useState([]);

    const[showModalDenunciations, setShowModalDenunciations] = useState(false);

    const sendNotifications = useCallback(async(message, title, type) =>{
        console.log(dataPF);
        await api.post('/admin/sendMessage', {
            message:message,
            title:title,
            type:type,
            uid: dataPF.firebaseUID,
        }, {
            headers: { 
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}` 
            }
        }).then(response=>
            console.log(response)
        ).catch(error=>{
            console.log(error)
        })
    
    }, [dataPF]);

    const handleClose = useCallback(async() =>{
        setShow(false)
    }, [setShow]);

    /*******BLOCK */

    const handleBlock  = useCallback(async() =>{
        setTitle('Bloquear')
        setText('Deseja bloquear esse usuário?')
        setShowModalConfirm(true)
    }, []);

    const blockFunc  = useCallback(async() =>{
        const bodyParameters = {
            key: "value"
        }

        await api.put(`/admin/block?uid=${dataPF.firebaseUID}&type=${ouvidoria? 'ouv':'user'}`, bodyParameters, 
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`
                }
            }
        ).then(response=>{
            setIsBlocked(true);
            console.log(response);
            setShowModalConfirm(false);//closes the first modal
            setShowConfirmAction(true);//calls the confirmation modal
            setTextConfirm('Usuário bloqueado com sucesso!');//sets the confirmation modal message
            changeStatus();//makes another api call
            setShow(false);//closes the main modal
            setShowProgress(false);//to disable the circular progress
            if (dataPF.deviceToken != null || undefined) {
                sendNotifications(`Você foi bloqueado do sistema. \nEmail: ${dataPF.email}`, `Bloqueio de conta!`, 'user', dataPF.firebaseUID);
            }
        }).catch( () =>{
            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)
            setTextConfirm('Erro ao bloquear usuário!')
            setShowProgress(false)//to disable the circular progress
        })
    }, [changeStatus, dataPF.deviceToken, dataPF.email, dataPF.firebaseUID, ouvidoria, sendNotifications, setShow])

    const handleUnBlock  = useCallback(async() =>{
        setTitle('Desbloquear')
        setText('Deseja desbloquear esse usuário?')
        setShowModalConfirm(true)
    }, []);

    const unblockFunc = useCallback(async() =>{
        const bodyParameters = {
            key: "value"
        }

        await api.put(`/admin/unblock?uid=${dataPF.firebaseUID}&type=${ouvidoria? 'ouv':'user'}`, bodyParameters,
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                }
            }
        ).then(()=>{
            setIsBlocked(false);
            setShowModalConfirm(false);//closes the first modal
            setShowConfirmAction(true);//calls the confirmation modal
            setTextConfirm('Usuário desbloqueado com sucesso!');//sets the confirmation modal message
            changeStatus();//makes another api call
            setShow(false);//closes the main modal
            setShowProgress(false);//to disable the circular progress

            // console.log(response);
        }).catch(error=>{
            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)
            setTextConfirm('Erro ao desbloquear usuário!')
            setShowProgress(false)//to disable the circular progress

            console.log(error.message);
        })
    }, [changeStatus, dataPF.firebaseUID, ouvidoria, setShow]);
    /*********ALERT */
    const handleAlert  = useCallback(async() =>{
        setTitle('Alertar')
        setText('Deseja emitir um alerta de mau uso do aplicativo para esse usuário?')
        setShowAlertModal(true)
    }, []);

    /******DELETE */
    const handleDelete =useCallback(async() =>{
        setTitle('Excluir')
        setText('Deseja excluir esse usuário permanentemente?')
        setShowModalConfirm(true)
    }, []);
    
    const deleteFunc = useCallback(async() =>{
        console.log('delete')
        

        await api.delete(`/admin/deleteUser?uid=${dataPF.firebaseUID}&type=${ouvidoria? 'ouv':'user'}`,
        {
            headers: {
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                
            }
        }
        ).then(()=>{
            console.log('delete')
            // console.log(response)
            
            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)//calls the confirmation modal
            setTextConfirm('Usuário deletado com sucesso!')//sets the confirmation modal message
            changeStatus()//makes another api call
            setShow(false)//closes the main modal
            setShowProgress(false)//to disable the circular progress

        }).catch(()=>{
            setShowModalConfirm(false)//closes the first modal
            setShowConfirmAction(true)
            setTextConfirm('Erro ao excluir usuário!')
            setShowProgress(false)//to disable the circular progress

        })
    }, [changeStatus, dataPF.firebaseUID, ouvidoria, setShow]);

    const alertFunc = useCallback(async() =>{
        console.log('alert')

        const data = {
            email:dataPF.email,
            text:alertMessage,
            subject:"Alerta do Aplicativo de Segurança da Mulher"
        }

        await api.post('/admin/sendEmail', data,
            {
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                },
            }
        ).then(()=>{

            setShowAlertModal(false)//closes the first modal
            setShowConfirmAction(true)//calls the confirmation modal
            setTextConfirm('Alerta enviado com sucesso!')//sets the confirmation modal message
            setShowProgress(false)//to disable the circular progress

            sendNotifications(`Email: ${dataPF.email}\n`+ alertMessage, `Você recebeu um alerta!`, 'user', dataPF.firebaseUID)

        }).catch(error=>{
            console.log(error);
            setShowAlertModal(false)//closes the first modal
            setShowConfirmAction(true)
            setTextConfirm('Erro ao enviar alerta!')
            setShowProgress(false)//to disable the circular progress

        })
    }, [alertMessage, dataPF.email, dataPF.firebaseUID, sendNotifications]);

    const handleGetDenunces = useCallback(async() => {
        api.get('/admin/historic', {
            headers: { 
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
                uid: dataPF.firebaseUID,
                type: 'user',
            }
        }).then((response) => {
            setDenunces(response.data.denunciations);
        }).catch(() => {
            
        });
    }, [dataPF.firebaseUID]);

    const handleModal = useCallback(async (denunce) => {
        //console.log('clicou em handleModal ver denuncias');
        try {
            setDenunciations(denunce);
        }catch(error){
            console.log(error);
        }
        setShowModalDenunciations(true);
        //denunce.setShowModal(true);
    }, [setDenunciations]);

    const setNotNew = useCallback(async() => {
        api.put('/admin/setAsNotNew', 
        {id: dataPF._id},
        {
            headers: { 
                authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,
            },
        }).then(() => {
            //console.log(response, 'resSetNotNew');
        }).catch(() => {
            //console.log(error, 'errorSetNotNew');
        });
    },[dataPF._id]);

    useEffect(() => {
        if(!ouvidoria && dataPF.historic !== undefined) {
            handleGetDenunces();
        }
        if (dataPF.blocked) {
            setIsBlocked(true);
        }
        if (dataPF.is_new) {
            setNotNew();
        }
        //console.log(dataPF);
    }, [dataPF, handleGetDenunces, ouvidoria, setNotNew]);

    return(
        <div>
            <Dialog
                open={show} 
                aria-labelledby="draggable-dialog-title" 
                maxWidth='md'
                onClose={()=>setShow(false)}
            >
                <DialogContent>
                    <div className='modal-pf'>
                        <div>
                            <img src={Cross} alt="" onClick={handleClose} className='cross-modal'/>
                        </div>
                        <h2 className='modal-pj-title'>Dados do usuário</h2>

                        <div className='modal-pj-info'>
                            <p className='modal-header-description mgrtop1'>Nome: 
                                <p id='nome-dados' className='modal-header-description des-color'>{dataPF.name}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>Email: 
                                <p id='email-dados' className='modal-header-description des-color'>{dataPF.email}</p>
                            </p>
                            <p className='modal-header-description mgrtop1'>CPF: 
                                <p id='cpf-dados' className='modal-header-description des-color'> {dataPF.cpf}</p>
                            </p>
                            {
                            ouvidoria? null : 
                                <p className='modal-header-description mgrtop1'>Telefone: 
                                    <p id='phone-dados' className='modal-header-description des-color'> {dataPF.phone}</p>
                                </p>
                            }
                        </div>
                        
                        { ouvidoria ? null: 
                            <>
                                <h2 className='modal-pj-title'>Denúncias realizadas</h2>
                                    {denunces.length > 0 ?
                                        <>
                                            {denunces.map((denunce) => (
                                                <div className='modal-pf-denunciation'>
                                                    <div id='card-comentario-resposta'className='modal-content-card' >
                                                        <div className='modal-pf-card'>
                                                            <p className = 'modal-content-date'>{denunce.created}</p>
                                                        </div>
                                                        <p id='comentario'className='modal-content-comment'>
                                                            {denunce.title}
                                                        </p>
                                                        <p 
                                                            className='card-profiles-text-button' 
                                                            id='show-data-button'
                                                            onClick={() => {handleModal(denunce)}}
                                                        >
                                                            Ver denúncia
                                                        </p>
                                                    </div> 
                                                </div>
                                            ))}
                                        </>


                                    :
                                        <div className='modal-pf-denunciation'>
                                            <div id='card--resposta'className='modal-content-card' >
                                                <p id='comentario'className='modal-content-comment'>Esse usuario ainda não realizou denuncias.</p>
                                            </div> 
                                        </div>
                                    }
                            </>
                        } 

                        <hr/>

                        <div className='modal-pj-buttons'>
                            
                            {
                                dataPF.blocked | isBlocked ?                  
                                    <div id='bloq-button' className='modal-pj-buttons-combo' onClick={handleUnBlock}>
                                        <img src={UnBlockIcon} alt=""/>
                                        <p>Desbloquear</p>
                                    </div> 
                                :
                                    <div id='bloq-button' className='modal-pj-buttons-combo' onClick={handleBlock}>
                                        <img src={BlockIcon} alt=""/>
                                        <p>Bloquear</p>
                                    </div> 
                            }

                            {
                                ouvidoria?null:
                                <div id='alert-button' className='modal-pj-buttons-combo' onClick={handleAlert}>
                                    <img src={AlertIcon} alt=""/>
                                    <p>Emitir Alerta</p>
                                </div>
                            }

                            <div id='excluir-button' className='modal-pj-buttons-combo redclr' onClick={handleDelete}>
                                <img src={TrashIcon} alt=""/>
                                <p>Excluir usuário</p>
                            </div>
                            
                        </div>
                    </div>
                </DialogContent>
            </Dialog>

            <ConfirmModal 
                showModal={showModalConfirm}
                decline={setShowModalConfirm}
                alert={alertFunc}
                block={blockFunc}
                delete={deleteFunc}
                unblock={unblockFunc}
                title={title}
                text={text}
                showProgress={showProgress}
                setShowProgress={setShowProgress}
            />

            <AlertModal //shows the alert options
                showModal={showAlertModal}
                decline={setShowAlertModal}
                alert={alertFunc}
                title={'Alerta'}
                setMessage={setAlertMessage}
                showProgress={showProgress}
                setShowProgress={setShowProgress}
                PF
            />

            <ConfirmAction // confirms the success of a action
                showModal={showConfirmAction}
                setShow={setShowConfirmAction}
                text={textConfirm}
            />

            <ModalDenunciations 
                show={showModalDenunciations} 
                setShow={setShowModalDenunciations} 
            />
        </div>
    )
}